import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import {
  GlameraIconBase,
  GlameraIconDefinition,
  GLAMERA_ICON_HOST_TEMPLATE,
} from '@glamera/animated-icons/core';

export const GLM_USER_X: GlameraIconDefinition = {
  name: 'user-x',
  viewBox: '0 0 24 24',
  svg: `
    <path class="glm-user-x-body" d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
    <circle class="glm-user-x-head" cx="9" cy="7" r="4"></circle>
    <g class="glm-user-x-cross">
      <line class="glm-user-x-cross-line" x1="17" x2="22" y1="8" y2="13"></line>
      <line class="glm-user-x-cross-line" x1="22" x2="17" y1="8" y2="13"></line>
    </g>
  `.trim(),
};

@Component({
  standalone: true,
  selector: 'glamera-user-x-icon',
  template: GLAMERA_ICON_HOST_TEMPLATE,
  styleUrls: ['../../core/src/lib/base/icon-base.scss', './user-x.animation.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UserXIconComponent extends GlameraIconBase {
  readonly iconDef = GLM_USER_X;

  constructor(sanitizer: DomSanitizer, cdr: ChangeDetectorRef) {
    super(sanitizer, cdr);
  }
}
